import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition, IconPrefix } from '@fortawesome/free-brands-svg-icons';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import {
  faBed,
  faCouch,
  faHotTub,
  faLeaf,
  faPhone,
  faSun,
  faTv,
  faWater,
  faWifi,
} from '@fortawesome/free-solid-svg-icons';
import { SeoService } from '@geekeno/ngx-website/services';

@Component({
  selector: 'app-rooms',
  imports: [
    MatCardModule,
    MatButtonModule,
    FontAwesomeModule,
    MatAccordion,
    MatExpansionModule,
    RouterLink,
  ],
  templateUrl: './rooms.component.html',
  styleUrl: './rooms.component.scss',
})
export class RoomsComponent {
  private readonly faAC: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'ac' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'M22 3.6V11H2V3.6a.6.6 0 0 1 .6-.6h18.8a.6.6 0 0 1 .6.6M18 7h1M2 11l.79 2.584A2 2 0 0 0 4.702 15H6m16-4l-.79 2.584A2 2 0 0 1 19.298 15H18m-8.5-.5s0 7-3.5 7m8.5-7s0 7 3.5 7m-6-7v7',
    ],
  };
  private readonly faKettle: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'kettle' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'M6 19V6L3 2h15v3h2q.825 0 1.413.588T22 7v5q0 .825-.587 1.413T20 14h-2v5zm12-7h2V7h-2zm-6 4h3V5h-3zm-9 6v-2h18v2z',
    ],
  };
  private readonly faHairDryer: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'hair-dryer' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'M22 9a4.32 4.32 0 0 1-2.22-.55A3.4 3.4 0 0 0 18 8V7a4.32 4.32 0 0 1 2.22.55A3.4 3.4 0 0 0 22 8m0-2a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 5v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 7m0 3a3.4 3.4 0 0 1-1.78-.45A4.32 4.32 0 0 0 18 9v1a3.4 3.4 0 0 1 1.78.45A4.32 4.32 0 0 0 22 11m-12 1.73A70.39 70.39 0 0 0 17 11V4s-6.5-2-9.5-2a5.5 5.5 0 0 0-1.38 10.82L7 19h1a3 3 0 0 0 1.46 2.33A3.15 3.15 0 0 1 11 24h1a4.12 4.12 0 0 0-1.91-3.45C9.39 20 9 19.63 9 19h1m-2.5-9A2.5 2.5 0 1 1 10 7.5A2.5 2.5 0 0 1 7.5 10',
    ],
  };
  private readonly faTable: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'table' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'M2 7h20v3h-2l1 9h-2.5l-.56-5H6.06l-.56 5H3l1-9H2zm15.5 3h-11l-.21 2h11.42z',
    ],
  };
  private readonly faRobe: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'sofa' as IconName,
    icon: [
      512,
      512,
      [],
      '',
      'M255.563 19.313c-8.59.207-18.054 4.34-28.22 12.906L153.75 137.874l77.625 36.75l-35.25-31.906c49.398-102.846 72.005-100.992 117.78 0l-34.842 31.56l77.343-36.405l-73.78-105.906c-9.694-9.432-18.4-12.867-27.063-12.657zm82.593 147.812L258.75 204.5l-4 1.875l-3.97-1.875l-76.56-36.25L69.343 291.094l18.75 14.125l66.03 15.06l28.94-118.217l17.217 8.156l-69.53 283.905h92.906l15.594-265.47l15.594 7.376l17.75-8.374l15.656 266.47h92.906l-69.75-284.72l17.25-8.125l29.22 119.25l71.687-16.405L444 291.095zM103.094 327.813a30.642 30.642 0 0 0-1.97 10.812c0 16.984 13.767 30.75 30.75 30.75a30.8 30.8 0 0 0 10.69-1.906l7.092-29.033l-46.562-10.625zm306.812 0l-47.562 10.875l6.906 28.28a30.603 30.603 0 0 0 11.875 2.407c16.984 0 30.75-13.766 30.75-30.75c0-3.81-.706-7.448-1.97-10.813z',
    ],
  };
  private readonly faFridge: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'fridge' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'M12.0564 1.25H11.9436C10.1058 1.24998 8.65019 1.24997 7.51098 1.40314C6.33856 1.56076 5.38961 1.89288 4.64124 2.64124C3.89288 3.38961 3.56076 4.33856 3.40314 5.51098C3.24997 6.65019 3.24998 8.10582 3.25 9.94357V13.0564C3.24998 14.8942 3.24997 16.3498 3.40314 17.489C3.56076 18.6614 3.89288 19.6104 4.64124 20.3588C5.10027 20.8178 5.63476 21.1202 6.25 21.3218V22C6.25 22.4142 6.58579 22.75 7 22.75H8C8.41421 22.75 8.75 22.4142 8.75 22V21.7042C9.65677 21.75 10.7147 21.75 11.9435 21.75H12.0564C13.2852 21.75 14.3432 21.75 15.25 21.7042V22C15.25 22.4142 15.5858 22.75 16 22.75H17C17.4142 22.75 17.75 22.4142 17.75 22V21.3218C18.3652 21.1202 18.8997 20.8178 19.3588 20.3588C20.1071 19.6104 20.4392 18.6614 20.5969 17.489C20.75 16.3498 20.75 14.8942 20.75 13.0565V9.94359C20.75 8.10585 20.75 6.65018 20.5969 5.51098C20.4392 4.33856 20.1071 3.38961 19.3588 2.64124C18.6104 1.89288 17.6614 1.56076 16.489 1.40314C15.3498 1.24997 13.8942 1.24998 12.0564 1.25ZM5.7019 3.7019C6.12511 3.27869 6.70476 3.02502 7.71085 2.88976C8.73851 2.75159 10.0932 2.75 12 2.75C13.9068 2.75 15.2615 2.75159 16.2892 2.88976C17.2952 3.02502 17.8749 3.27869 18.2981 3.7019C18.7213 4.12511 18.975 4.70476 19.1102 5.71085C19.2484 6.73851 19.25 8.09318 19.25 10V10.75H4.75V10C4.75 8.09318 4.75159 6.73851 4.88976 5.71085C5.02502 4.70476 5.27869 4.12511 5.7019 3.7019ZM4.75 12.25H19.25V13C19.25 14.9068 19.2484 16.2615 19.1102 17.2892C18.975 18.2952 18.7213 18.8749 18.2981 19.2981C17.8749 19.7213 17.2952 19.975 16.2892 20.1102C15.2615 20.2484 13.9068 20.25 12 20.25C10.0932 20.25 8.73851 20.2484 7.71085 20.1102C6.70476 19.975 6.12511 19.7213 5.7019 19.2981C5.27869 18.8749 5.02502 18.2952 4.88976 17.2892C4.75159 16.2615 4.75 14.9068 4.75 13V12.25Z M17.75 14C17.75 13.5858 17.4142 13.25 17 13.25C16.5858 13.25 16.25 13.5858 16.25 14V16C16.25 16.4142 16.5858 16.75 17 16.75C17.4142 16.75 17.75 16.4142 17.75 16V14Z M17.75 7C17.75 6.58579 17.4142 6.25 17 6.25C16.5858 6.25 16.25 6.58579 16.25 7V9C16.25 9.41422 16.5858 9.75 17 9.75C17.4142 9.75 17.75 9.41422 17.75 9V7Z',
    ],
  };

  private readonly faToiletries: IconDefinition = {
    prefix: 'fat' as IconPrefix,
    iconName: 'toothbrush' as IconName,
    icon: [
      24,
      24,
      [],
      '',
      'm17.86 1.5l-4.95 4.93l2.12 2.12l1.06-1.05l-1.06-1.07l2.83-2.83l1.06 1.06L20 3.6m1.4 0l-5.84 5.84l-2.13.71L3 20.57L4.43 22l5.65-5.67l4.25 4.24l4.24-4.24l-4.24-4.24l.17-.19l2.13-.71l4.77-4.76c.78-.78.78-2.05 0-2.83m-14.85.71L2.31 8.55l4.95 4.95l4.24-4.24m6.72 8.84l-2.13 2.12l1.41 1.41l2.13-2.13Z',
    ],
  };

  icons = {
    bed: faBed,
    wakeUpService: faSun,
    garden: faLeaf,
    sea: faWater,
    tv: faTv,
    jacuzzi: faHotTub,
    toiletries: this.faToiletries,
    wifi: faWifi,
    phone: faPhone,
    hairDryer: this.faHairDryer,
    kettle: this.faKettle,
    table: this.faTable,
    sofa: faCouch,
    bathRobe: this.faRobe,
    fridge: this.faFridge,
    ac: this.faAC,
  };

  rooms = [
    {
      title: 'Luxury Sea View Villa with Jacuzzi',
      src: '/assets/images/panoramic-sea-view.webp',
      description:
        'This villa is spacious and bright, with a large window overlooking the azure sea. It is situated on the ground floor and faces the shores of Agonda beach. It also includes a jacuzzi to relax in while you watch the waves by the shore. The room has a comfortable king-sized bed, a cozy sofa, writing table, and a mini-fridge. The room also has a balcony, where guests can enjoy the fresh breeze and the stunning view of the beach. The hotel room is ideal for a relaxing and romantic getaway.',
      mainView: 'sea',
      hasJacuzzi: true,
    },
    {
      title: 'Panoramic Sea View Villa',
      src: '/assets/images/panoramic-sea-view-room.webp',
      description:
        'A elegant and luxurious villa, with a wall-to-wall breathtaking view of the sea. Being on the first floor, you can get a very clear view of the serene waves lapping on the shores of Agonda beach. There is a plush king-sized bed, a stylish sofa, writing table, and a mini-fridge. The room also has a terrace balcony, where guests can relax on the lounge chairs and admire the scenery. The hotel room is perfect for a memorable and indulgent vacation.',
      mainView: 'sea',
      hasJacuzzi: false,
    },
    {
      title: 'Deluxe Sea View Villa',
      src: '/assets/images/deluxe-sea-view-villa.webp',
      description:
        'This first floor villa is cozy and airy, with a spectacular view of the sea. The room has a soft king-sized bed, a wooden writing table, a mini-fridge, and a sofa to lounge in. The balcony is perfect for waking up and having breakfast while taking in the splendid view of the ocean. The hotel room is great for a adventurous and scenic stay.',
      mainView: 'sea',
      hasJacuzzi: false,
    },
    // {
    //   title: 'Garden View Room',
    //   src: '/assets/images/SLK59795.jpg',
    //   description:
    //     'Our Garden view room is charming and rustic, with a large window that overlooks a lush garden. The room has a cozy king bed, and state of the art amenities. The bathroom is colorful and floral, with a shower, a bidet, and a soap dispenser. The room also has a patio, where guests can sit on the rocking chairs and enjoy the view of the flowers. The hotel room is ideal for a peaceful and nature-loving stay.',
    //   mainView: 'garden',
    //   hasJacuzzi: false,
    // },
  ];

  constructor(seo: SeoService) {
    seo.setSEO({
      title: 'Luxurious Suites & Rooms | The Shore Agonda',
      description:
        "Discover cozy cottages with breathtaking views at our boho-chic resort. Rest and relax, and when you're ready walk along the shores of Palolem.",
    });
  }
}
